<template>
  <div class="processing-status-skeleton">
    <div class="skeleton-header">
      <div class="skeleton-icon" />
      <div class="skeleton-title" />
    </div>
    <div class="skeleton-content">
      <div class="skeleton-line skeleton-line--1" />
      <div class="skeleton-line skeleton-line--2" />
      <div class="skeleton-line skeleton-line--3" />
    </div>
    <div class="skeleton-action-section">
      <div class="skeleton-action-item">
        <div class="skeleton-action-icon" />
        <div class="skeleton-action-text">
          <div class="skeleton-line skeleton-line--sm" />
          <div class="skeleton-line skeleton-line--sm skeleton-line--60" />
        </div>
      </div>
      <div class="skeleton-action-item">
        <div class="skeleton-action-icon" />
        <div class="skeleton-action-text">
          <div class="skeleton-line skeleton-line--sm" />
          <div class="skeleton-line skeleton-line--sm skeleton-line--60" />
        </div>
      </div>
    </div>
    <div class="skeleton-button" />
  </div>
</template>

<script>
export default {
  name: 'ProcessingStatusSkeleton',
}
</script>

<style lang="scss" scoped>
.processing-status-skeleton {
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  margin-inline: auto;

  @media(max-width: 767px) {
    padding: 24px;
    border-radius: 12px;
  }
}

.skeleton-header {
  text-align: center;
  margin-bottom: 28px;
}

.skeleton-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  border-radius: 50%;
  background-color: #e5e7eb;
  animation: skeleton-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.skeleton-title {
  width: 220px;
  height: 24px;
  margin: 0 auto;
  border-radius: 4px;
  background-color: #e5e7eb;
  animation: skeleton-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.skeleton-content {
  margin-bottom: 24px;
  text-align: center;
}

.skeleton-line {
  height: 14px;
  border-radius: 4px;
  background-color: #e5e7eb;
  animation: skeleton-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }

  &--1 {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }

  &--2 {
    width: 70%;
    margin-left: auto;
    margin-right: auto;
  }

  &--3 {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
  }

  &--sm {
    height: 12px;
    margin-bottom: 6px;
  }

  &--60 {
    width: 60%;
  }
}

.skeleton-action-section {
  background: #f9fafb;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}

.skeleton-action-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

.skeleton-action-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 4px;
  background-color: #e5e7eb;
  animation: skeleton-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.skeleton-action-text {
  flex: 1;
}

.skeleton-button {
  width: 140px;
  height: 40px;
  margin-inline: auto;
  border-radius: 8px;
  background-color: #e5e7eb;
  animation: skeleton-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Tailwind-style animate-pulse: opacity pulse */
@keyframes skeleton-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
